import Top from '../components/Top'
import page from '~utils/page'
import { NETWORK } from '~shared/Nav'

// eslint-disable-next-line import/no-unused-modules
export default page(Top, {
    highlight: NETWORK,
    streamrClient: true,
})
